import React, { useState, useEffect, useRef } from 'react';
import DataGrid, {
    Column,
    ColumnChooser,
    Export,
    FilterRow,
    Grouping,
    GroupPanel,
    HeaderFilter,
    KeyboardNavigation,
    LoadPanel,
    MasterDetail,
    Paging,
    Scrolling,
    SearchPanel,
    Selection,
} from 'devextreme-react/data-grid';
import { Template } from 'devextreme-react/core/template';
import { DateFormat } from '../../helpers/fixcodes';

const DispatchGrid = React.memo(React.forwardRef(function DispatchGrid({
    variant,
    dataSource,
    searchPanelText,
    selectedRowKeys,
    enterKeyAction,
    allowToAddDriverWorkingHours,
    onToolbarPreparing,
    onRowPrepared,
    onSelectionChanged,
    onOptionChanged,
    onExporting,
    renderDetail,
    toolbarItemRender,
    renderGridCell,
    renderReportingCell,
    renderDeBriefingCell,
    renderPickupTimeCell,
    renderPickupAddressCell,
    renderDropoffAddressCell,
    renderFlightInfoCell,
    renderJobIdCell,
    renderPaxNameCell,
    socketDataUpdated,
}, ref) {
    const wrapperRef = useRef(null);
    const [gridHeight, setGridHeight] = useState(500);

    debugger;

    useEffect(() => {
        const update = () => {
            if (!wrapperRef.current) return;
            const { top } = wrapperRef.current.getBoundingClientRect();
            setGridHeight(Math.max(300, window.innerHeight - top - 4));
        };
        update();
        window.addEventListener('resize', update);
        return () => window.removeEventListener('resize', update);
    }, []);

    if (variant === 'standard') {
        return (
            <div ref={wrapperRef} style={{ flex: '1 1 auto', minHeight: 0 }}>
                <DataGrid
                    ref={ref}
                    id="dispatch-grid-container"
                    name="gridDispatchedContainer"
                    dataSource={dataSource}
                    className="dx-datagrid-height"
                    height={gridHeight}
                    columnsAutoWidth={true}
                    showColumnLines={true}
                    showRowLines={true}
                    showBorders={true}
                    rowAlternationEnabled={false}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    onToolbarPreparing={onToolbarPreparing}
                    onRowPrepared={onRowPrepared}
                    selectedRowKeys={selectedRowKeys}
                    onSelectionChanged={onSelectionChanged}
                    onOptionChanged={onOptionChanged}
                >
                    <KeyboardNavigation enterKeyAction={enterKeyAction} />
                    <MasterDetail enabled={true} autoExpandAll={false} render={renderDetail} />
                    <Column dataField="pickupDateTime" caption="Pick-up Time" width={120} allowFiltering={false} allowSorting={true} format={DateFormat.DateTime24Format} dataType="datetime" />
                    <Column dataField="driverName" caption="Driver Name" width={150} allowFiltering={true} allowSorting={true} />
                    <Column dataField="driverMobileNo" caption="Driver Mobile" width={100} allowFiltering={true} allowSorting={true} />
                    <Column dataField="driverWorkingHours" caption="Driver working Hrs" width={120} allowFiltering={true} allowSorting={true} visible={allowToAddDriverWorkingHours === "true"} />
                    <Column dataField="flightInfo" caption="Flight #" width={100} allowFiltering={true} allowSorting={true} cellRender={renderFlightInfoCell} />
                    <Column dataField="puStreet" caption="Pick-up" width={200} allowFiltering={true} allowSorting={true} />
                    <Column dataField="doStreet" caption="Drop Off" width={200} allowFiltering={true} allowSorting={true} />
                    <Column dataField="vehicleNo" caption="Vehicle #" width={100} allowFiltering={true} allowSorting={true} />
                    <Column dataField="vehicleTypeName" caption="V Type" width={80} allowFiltering={true} allowSorting={true} />
                    <Column dataField="paxName" caption="Pax Name" width={150} allowFiltering={true} allowSorting={true} cellRender={renderPaxNameCell} />
                    <Column dataField="rideId" caption="Ride Id" width={90} allowFiltering={true} allowSorting={true} />
                    <Column dataField="driverUserName" caption="Driver #" width={100} visible={false} allowFiltering={true} allowSorting={true} />
                    <Column dataField="noOfAdults" caption="Pax" width={70} allowFiltering={true} allowSorting={true} />
                    <Column dataField="tripStatusDesc" caption="Pax Status" width={150} allowFiltering={true} allowSorting={true} />
                    <Column dataField="" width={90} caption="ETA/ETD" allowFiltering={false} allowSorting={false} cellRender={renderGridCell} />
                    <Column dataField="flightStatus" caption="Flight Status" width={100} allowFiltering={true} allowSorting={true} />
                    <Column dataField="flightTime" caption="Flight Time" width={80} allowFiltering={false} allowSorting={true} />
                    <Column dataField="flightEST" caption="Flight Est. Time" width={150} allowFiltering={true} allowSorting={true} visible={false} />
                    <Column dataField="flightATA" caption="Flight Actual Time" width={150} allowFiltering={true} allowSorting={true} />
                    <Column dataField="flightTerminal" caption="Flight Term." width={100} allowFiltering={true} allowSorting={true} />
                    <Column dataField="flightGate" caption="Flight Gate" width={100} allowFiltering={true} allowSorting={true} />
                    <Column dataField="permanentRemark" caption="Note" width={150} allowFiltering={true} allowSorting={true} />
                    <Column dataField="specialInsruction" caption="Dispatch Note" width={150} allowFiltering={true} allowSorting={true} />
                    <Column dataField="dispatcherName" caption="Dispatcher" width={100} allowFiltering={true} allowSorting={true} />
                    <Column dataField="noOfCharter" caption="Charter" width={80} allowFiltering={true} allowSorting={true} />
                    <Column dataField="preAssignedAcknowledgeStatus" caption="PreAssigned Status" width={80} allowFiltering={true} allowSorting={true} />
                    <Column dataField="assignedTime" caption="Assign Time" width={100} allowFiltering={false} allowSorting={true} />
                    <Column dataField="onLocationTime" caption="On Site" width={80} allowFiltering={false} allowSorting={true} />
                    <Column dataField="onLoadTime" caption="Load Time" width={80} allowFiltering={false} allowSorting={true} />
                    <Column dataField="onCompletedTime" caption="Completion Time" width={125} allowFiltering={false} allowSorting={true} />
                    <Column dataField="meetGreetName" caption="Greeter Name" width={120} allowFiltering={false} allowSorting={true} />
                    <Template name="multipleDrivers" render={toolbarItemRender} />
                    <ColumnChooser enabled={false} />
                    <Grouping autoExpandAll={true} />
                    <HeaderFilter visible={true} />
                    <SearchPanel visible={true} text={searchPanelText} highlightCaseSensitive={false} highlightSearchResults={true} />
                    <Export visible={true} enabled={true} allowExportSelectedData={true} />
                    <GroupPanel visible={false} />
                    <LoadPanel enabled={false} />
                    <Scrolling mode="virtual" rowRenderingMode="virtual" showScrollbar="always" />
                    <Paging enabled={false} />
                    <Selection mode="multiple" selectAllMode="allPages" showCheckBoxesMode="always" />
                </DataGrid>
            </div>
        );
    }

    return (
        <div ref={wrapperRef} style={{ flex: '1 1 auto', minHeight: 0 }}>
            <DataGrid
                ref={ref}
                id="dispatch-grid-container-custom"
                name="gridDispatchedContainer"
                dataSource={dataSource}
                className="dx-datagrid-height"
                height={gridHeight}
                columnsAutoHeight={true}
                columnsAutoWidth={true}
                showColumnLines={true}
                showRowLines={true}
                showBorders={true}
                rowAlternationEnabled={false}
                allowColumnResizing={true}
                columnResizingMode='widget'                
                onToolbarPreparing={onToolbarPreparing}
                onRowPrepared={onRowPrepared}
                selectedRowKeys={selectedRowKeys}
                onSelectionChanged={onSelectionChanged}
                onOptionChanged={onOptionChanged}
                onExporting={onExporting}
            >
                <KeyboardNavigation enterKeyAction={enterKeyAction} />
                <MasterDetail enabled={true} autoExpandAll={false} render={renderDetail} />
                <Column dataField="flightInfo" caption="Flight #" width={100} allowFiltering={true} allowSorting={true} cellRender={renderFlightInfoCell} />
                <Column dataField="flightTerminal" caption="Flight Terminal" width={100} allowFiltering={true} allowSorting={true} />
                <Column dataField="flightTime" caption="Flight Time" width={80} allowFiltering={false} allowSorting={true} />
                <Column dataField="flightATA" caption="Flight Actual Time" width={130} allowFiltering={false} allowSorting={true} format={DateFormat.DateTime24Format} dataType="datetime" />
                <Column dataField="dutyReportingTime" caption="Reporting Time" width={130} allowFiltering={false} allowSorting={true} cellRender={renderReportingCell} />
                <Column dataField="deBriefingTime" caption="DeBriefing Time" width={120} allowFiltering={false} allowSorting={true} cellRender={renderDeBriefingCell} />
                <Column dataField="pickupDateTime" caption="Pick-up Time" width={120} allowFiltering={false} allowSorting={true} format={DateFormat.DateTime24Format} dataType="datetime" cellRender={renderPickupTimeCell} />
                <Column dataField="activityCode" caption="Activity Code" width={150} allowFiltering={true} allowSorting={true} />
                <Column dataField="paxName" caption="Crew Name" width={150} allowFiltering={true} allowSorting={true} cellRender={renderPaxNameCell} />
                <Column dataField="paxMobileNo" caption="Crew Mobile" width={100} allowFiltering={true} allowSorting={true} />
                <Column dataField="paxType" caption="Rank." width={70} allowFiltering={true} allowSorting={true} />
                <Column dataField="rideType" caption="Trip Type" width={100} allowFiltering={true} allowSorting={true} />
                <Column dataField="puStreet" caption="Pick-up" width={200} allowFiltering={true} allowSorting={true} cellRender={renderPickupAddressCell} />
                <Column dataField="doStreet" caption="Drop Off" width={200} allowFiltering={true} allowSorting={true} cellRender={renderDropoffAddressCell} />
                <Column dataField="vehicleNo" caption="Vehicle #" width={100} allowFiltering={true} allowSorting={true} />
                <Column dataField="jobId" caption="Job No" width={100} allowFiltering={true} allowSorting={true} cellRender={renderJobIdCell} />
                <Column dataField="allowClubbing" caption="Allow Clubbing" width={100} allowFiltering={true} allowSorting={true} />
                <Column dataField="rideConfirmed" caption="Ride Confirmation" width={120} allowFiltering={true} allowSorting={true} />
                <Column dataField="otpVerifiedStatus" caption="OTP Verify Status" width={120} allowFiltering={true} allowSorting={true} />
                <Column dataField="clubbedStatus" caption="Clubbing Status" width={100} allowFiltering={true} allowSorting={true} />
                <Column dataField="driverName" caption="Driver Name" width={150} allowFiltering={true} allowSorting={true} />
                <Column dataField="driverWorkingHours" caption="Driver working Hrs" width={120} allowFiltering={true} allowSorting={true} visible={allowToAddDriverWorkingHours === "true"} />
                <Column dataField="tripStatusDesc" caption="Ride Status" width={150} allowFiltering={true} allowSorting={true} />
                <Column dataField="cancelledDate" caption="Cancellation date" width={150} allowFiltering={true} allowSorting={true} format={DateFormat.DateTime24Format} dataType="datetime" />
                <Column dataField="dispatcherName" caption="Dispatcher" width={100} allowFiltering={true} allowSorting={true} />
                <Column dataField="assignedTime" caption="Assign Time" width={100} allowFiltering={false} allowSorting={true} />
                <Column dataField="onLocationTime" caption="On Location" width={80} allowFiltering={false} allowSorting={true} />
                <Column dataField="onLoadTime" caption="Boarded" width={80} allowFiltering={false} allowSorting={true} />
                <Column dataField="onUnloadTime" caption="Drop" width={80} allowFiltering={false} allowSorting={true} />
                <Column dataField="onCompletedTime" caption="Completed" width={125} allowFiltering={false} allowSorting={true} />
                <Column dataField="assignedStatus" caption="Assigned Status" width={125} allowFiltering={false} allowSorting={true} />
                <Column dataField="rideId" caption="Ride Id" width={90} allowFiltering={true} allowSorting={true} />
                <Template name="multipleDrivers" render={toolbarItemRender} />
                <ColumnChooser enabled={false} />
                <Grouping autoExpandAll={true} />
                <HeaderFilter visible={true} />
                <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                <Export visible={true} enabled={true} allowExportSelectedData={true} fileName="Dispatch" />
                <GroupPanel visible={false} />
                <LoadPanel enabled={false} />
                <Scrolling mode="virtual" rowRenderingMode="virtual" showScrollbar="always" />
                <Paging enabled={false} />
                <Selection mode="multiple" selectAllMode="allPages" showCheckBoxesMode="always" />
            </DataGrid>
        </div>
    );
}));

export default DispatchGrid;
